import { Box, Skeleton } from '@mui/material';

export default function EventListingCards() {
    return (
        <Box
            sx={{
                bgcolor: 'var(--primary-color)',
                flex: 1,
                minHeight: '92vh',
                display: 'flex',
                flexWrap: 'wrap',
                // padding: '1rem 2rem',
                gap: '1.8rem'
            }}
        >
            {[...Array(8)].map((_, index) => (
                <Skeleton
                    key={index}
                    variant="rounded"
                    height={465}
                    width={320}
                    sx={{
                        alignSelf: 'stretch',
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                        borderRadius: '2rem'
                    }}
                />
            ))}
        </Box>
    );
}